import { EllipseLabel } from '@/modules/global-components/ui/wrappers/EllipseLabel';
import type { LocationInterface } from '@/types/carrier-types';
import { Tag } from 'primereact/tag';
import { processTitleCase } from './utils';
import { TextWrapper as TexWrapperShipping } from '@/modules/export/shipping/invoices/components/components/preview-save/components/PdfWrappers';
import type { Nullable } from 'primereact/ts-helpers';
import { TextWrapper } from '@/modules/accounting/invoices/add/components/components/preview-save/components/PdfWrappers';
import type { TabPanelPassThroughMethodOptions } from 'primereact/tabview';
import { cn } from './utils/functionality-utils';
import type {
  ColumnPassThroughOptions,
  ColumnPassThroughMethodOptions,
} from 'primereact/column';

import { type Variants } from 'framer-motion';

export const locationTemplate = (option: LocationInterface) => {
  if (option) {
    return (
      <div className="flex w-full shrink-0 items-center justify-between gap-2">
        <div className="w-full min-w-0 font-bold">
          <EllipseLabel className="w-full" label={option.name}></EllipseLabel>
        </div>
        <Tag className="shrink-0 text-xs">
          {processTitleCase(option.location_type)}
        </Tag>
      </div>
    );
  }
  return <span>n/a</span>;
};

export const blockLoadUiTemplate = () => {
  return (
    <div className="text-6xl font-bold text-white">
      <i className="pi pi-spin pi-spinner text-6xl" />
    </div>
  );
};
export function stringSplitter(
  str: Nullable<string | number>,
  isDom?: boolean,
) {
  return String(str)
    .split('')
    .map((char, i) => (
      <TexWrapperShipping key={i}>
        {isDom && char === ' ' ? '\u00A0' : char}
      </TexWrapperShipping>
    ));
}

export function stringSplitterCustomer(
  str: Nullable<string | number>,
  isDom?: boolean,
) {
  return String(str)
    .split('')
    .map((char, i) => (
      <TextWrapper key={i}>
        {isDom && char === ' ' ? '\u00A0' : char}
      </TextWrapper>
    ));
}
export const tabsPT = {
  header: {
    className: '',
  },
  headerAction: (option: TabPanelPassThroughMethodOptions) => {
    return {
      className: cn(
        'items-center gap-2',
        option?.parent?.state.activeIndex === option?.context.index
          ? 'text-teal-600'
          : 'text-gray-200',
      ),
    };
  },
};
export const ColumnPt: ColumnPassThroughOptions = {
  bodyCell: (data: ColumnPassThroughMethodOptions) => {
    const rejectComments = data?.state.editingRowData.reject_comments;
    return { className: rejectComments ? 'border-b-transparent' : '' };
  },
};

export const slideVariants: Variants = {
  hidden: {
    height: 0,
    opacity: 0,
    y: -8,
  },
  visible: {
    height: 'auto',
    opacity: 1,
    y: 0,
  },
  exit: {
    height: 0,
    opacity: 0,
    y: -8,
  },
};
